import cn from "classnames";
import Button from "../common/Button";
import { useStaffView } from "./StaffView";

// The confirm / dismiss / restore / note controls on lead cards, styled like
// the Narrative / Interaction toggle in UploadModal: small outlined `Button`s,
// the chosen state filled in its colour (green for confirmed, red for dismiss).
type Kind = "confirm" | "dismiss" | "restore" | "note";

const LABELS = { confirm: "Confirm", dismiss: "Dismiss", restore: "Restore", note: "Add note" };

interface Props extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  kind: Kind;
  active?: boolean; // confirm: already confirmed
  label?: string;
}

const TriageButton: React.FC<Props> = ({ kind, active, label, className, ...rest }) => {
  // Staff portal view is read-only: keep the lead's state visible, drop the actions.
  const staffView = Boolean(useStaffView());
  const showsState = (kind === "confirm" && active) || kind === "restore";
  if (staffView && !showsState) return null;
  return (
  <Button
    type="button"
    variant="outline"
    size="xs"
    className={cn(
      "!border h-auto text-xs px-2.5 py-1 rounded-md",
      kind === "confirm" &&
        (active
          ? "bg-green-100 dark:bg-green-950/40 text-green-800 dark:text-green-400 border-green-500 hover:bg-green-200 dark:hover:bg-green-950/60"
          : "text-base-content/60 bg-base-100 hover:bg-green-50 dark:hover:bg-green-950/40"),
      kind === "dismiss" && "text-base-content/60 bg-base-100 hover:bg-red-50 dark:hover:bg-red-950/40 hover:text-red-700 dark:hover:text-red-400 hover:border-red-400",
      kind === "restore" && "bg-red-100 dark:bg-red-950/40 text-red-800 dark:text-red-400 border-red-500 hover:bg-red-200 dark:hover:bg-red-950/60",
      kind === "note" && "text-base-content/60 bg-base-100 hover:bg-base-200",
      className
    )}
    {...rest}
    disabled={staffView || rest.disabled}
  >
    {label ?? (kind === "confirm" && active ? "Confirmed" : kind === "restore" ? (staffView ? "Dismissed" : "Dismissed · Restore") : LABELS[kind])}
  </Button>
  );
};

export default TriageButton;
